import React, { useContext } from 'react';
import styled from 'styled-components';
import Button from '../Button';

import State from '../../context';

export const SingleSelection = ({ options, onChange, color, name, disabled = false }) => {
  const state = useContext(State);

  return options.map(option => {
    let validationClass = '';
    if(typeof option.correct !== 'undefined') {

      // Always indicate correct answer
      if(option.correct) {
        validationClass = 'correctAnswer';
      }

      // Only indicate wrong answer if user selected it
      if(option.checked && !option.correct) {
        validationClass = 'incorrectAnswer';
      }
    }

    return (<>
      <Label key={option.uuid} className={`single ${validationClass || ''} ${disabled ? 'disabled' : ''}`}>
        <Input type="radio" checked={option.checked} name={name} value={option.uuid} onChange={onChange} disabled={disabled} />
        <PseudoLabel>{option.option}</PseudoLabel>
      </Label>
      {option.correct && option.explanation ? <OptionExplanation>
        {option.image ? <img src={option.image} alt="" width="880" height="285"/> : null}
        <p dangerouslySetInnerHTML={{ __html: option.explanation }} />
        <Button as={'a'} primary={true} href={state.texts.finalLink}><span className="icon icon--arrow-right " aria-hidden="true"></span> {state.texts.finalLinkText}</Button>
      </OptionExplanation> : null}
    </>
    );
  });
};

export const MultiSelection = ({ options, onChange, color, disabled }) => {
  return options.map(option => {
    let validationClass = '';
    if(typeof option.correct !== 'undefined') {

      // Always indicate correct answer
      if(option.correct) {
        validationClass = 'correctAnswer';
      }

      // Only indicate wrong answer if user selected it
      if(option.checked && !option.correct) {
        validationClass = 'incorrectAnswer';
      }
    }

    return (
      <Label key={option.uuid} className={`multi ${validationClass || ''} ${disabled ? 'disabled' : ''}`}>
        <Input type="checkbox" checked={option.checked} value={option.uuid} onChange={onChange} disabled={disabled} />
        <PseudoLabel>{option.option}</PseudoLabel>
      </Label>
    );
  });
};

const PseudoLabel = styled.span`
  display: flex;
  font-size: 17px;
  line-height: normal;
  position: relative;
  user-select: none;

  &::before {
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: contain;
    border: 1px solid black;
    content: '';
    display: inline-block;
    flex: 0 0 auto;
    height: 25px;
    margin-right: 18px;
    width: 25px;
  }
`;

const Input = styled.input`
  opacity: 0;
  position: absolute;
  z-index: -1;

  &:checked + ${PseudoLabel}::before {
    background-color: transparent;
    border-color: #fff;
  }
`;

const Label = styled.label`
  background-color: var(--quiz-option-background-color);
  border-radius: 4px;
  cursor: pointer;
  display: block;
  margin: 0;
  padding: 14px;
  position: relative;

  &:focus-within {
    outline: 2px dashed green;
    outline-offset: 2px;
  }

  // Checkboxes have checkmarks
  &.multi {
    ${Input}:checked + ${PseudoLabel}::before {
     border: 2px solid green;
    }
  }

  // Radio buttons are round
  &.single {
    ${PseudoLabel}::before {
      border-radius: 100%;
    }

    ${Input}:checked {
      & + ${PseudoLabel}::before {
        border-color: #fff;
      }

      & + ${PseudoLabel}::after {
        background: #fff;
        border-radius: 100%;
        content: '';
        height: 17px;
        left: 4px;
        position: absolute;
        top: 4px;
        width: 17px;
      }
    }
  }

  &.disabled {
    cursor: default;
  }

  &.correctAnswer {
    background-color: var(--quiz-primary-color);
    color: var(--quiz-text-on-primary-color);
  }

  &.incorrectAnswer {
    box-shadow: 0px 0px 0px 2px red;
  }
`;

const OptionExplanation = styled.div`
  display: grid;
  gap: 28px;
  padding-block: 20px;
`;
